import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { User } from "../../../pages/login/login.model";
import superAdminLoginService from "./superAdminLoginService";

interface SuperAdminResetPasswordState {
    superAdminResetPasswordData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: SuperAdminResetPasswordState = {
  superAdminResetPasswordData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//login recover slice - forgot username & forgot password
export const superAdminResetPassword = createAsyncThunk("auth/reset-password", async (userData: User, thunkAPI) => {
  try {
    const response = await superAdminLoginService.superAdminResetPasswordService(userData);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const superAdminResetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    superAdminResetResetPassword: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminResetPassword.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminResetPassword.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdminResetPasswordData = action.payload;
      })
      .addCase(superAdminResetPassword.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { superAdminResetResetPassword } = superAdminResetPasswordSlice.actions;
